export type Debugger = (formatter: any, ...args: any[]) => void;

let importPromise: Promise<Pick<typeof import("debug"), "default">>;

export const createDebug = (name: string): Debugger => {
  const isEnabled = !!localStorage.getItem("debug");

  if (isEnabled) {
    importPromise = import("debug");
  }

  return (formatter: any, ...args: any[]) => {
    if (importPromise) {
      importPromise.then(({ default: debug }) => {
        debug(name)(formatter, ...args);
      });
    }
  };
};
